import React from 'react';
import { ImageBackground, StyleSheet, Text, Pressable, View } from 'react-native';
import PropTypes from 'prop-types';
import Theme from 'Theme';
import LinearGradient from 'react-native-linear-gradient';
import { ActivityIndicator, LineIndicator } from 'LocalGluons';
import { getAssetTitle } from '../../../utils';
import Icon from '../Icon';

const styles = StyleSheet.create({
    image: {
        height: 202,
        alignSelf: 'stretch',
        backgroundColor: '#020002'
    },
    header: {
        fontFamily: Theme.regularFont,
        fontSize: 18,
        color: Theme.primaryTextColor
    },
    titlesContainer: {
        flex: 1,
        justifyContent: 'flex-end',
        marginHorizontal: 11,
        marginVertical: 21
    },
    title: {
        fontFamily: Theme.ultraFont,
        fontSize: 27,
        color: Theme.primaryTextColor,
        maxWidth: '90%'
    },
    subTitle: {
        fontFamily: Theme.regularFont,
        fontSize: 18,
        color: Theme.primaryTextColor
    },
    line: {
        backgroundColor: Theme.primaryTextColor,
        height: 1.8,
        width: 15,
        marginVertical: 5
    },
    progressLine: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 5,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
});

const Promo = ({ data, onItemPress, style, testID }) =>
    data ? (
        <Pressable
            style={{ flex: 1 }}
            testID={testID}
            onPress={() => {
                if (typeof onItemPress === 'function') {
                    onItemPress(data.item, data);
                }
            }}
        >
            <ImageBackground
                style={[styles.image, style, !data.imageUrl && { backgroundColor: '#333333' }]}
                source={{ uri: data.imageUrl }}
            >
                <View style={{ flex: 1 }}>
                    {!data.isBlocked && (
                        <LinearGradient
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 0 }}
                            colors={['rgba(0,0,0,0.9)', 'rgba(0,0,0,0.0)']}
                            style={{ position: 'absolute', left: 0, width: 300, bottom: 0, top: 0 }}
                        />
                    )}
                    <View style={styles.titlesContainer}>
                        <Text style={styles.header}>{data.header}</Text>
                        {Boolean(data.header) && <View style={styles.line} />}
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <Text style={styles.title} numberOfLines={2}>
                                {getAssetTitle(data?.item)?.toUpperCase()}
                            </Text>
                            {data.isBlocked && (
                                <Icon
                                    name="lock"
                                    style={{ height: 25, width: 25, marginLeft: 8 }}
                                />
                            )}
                        </View>
                        <Text style={styles.subTitle} numberOfLines={2}>
                            {data.subTitle}
                        </Text>
                    </View>
                    <LineIndicator progress={data.progress} style={styles.progressLine} />
                </View>
            </ImageBackground>
        </Pressable>
    ) : (
        <View
            style={{
                flex: 1,
                alignSelf: 'stretch',
                alignContent: 'center',
                justifyContent: 'center',
                height: 202
            }}
        >
            <ActivityIndicator color={Theme.primaryActiveColor} size="large" />
        </View>
    );

Promo.propTypes = {
    data: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.any]),
    onItemPress: PropTypes.func.isRequired,
    style: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array]),
    testID: PropTypes.string
};

Promo.defaultProps = {
    style: null,
    testID: 'promo',
    data: {}
};
export default Promo;
